import { httpClient } from "../../../utils/HttpClient";
import { ApiEndpoint } from "../../../utils/ApiEndpoint";
import axios from "axios";

export const uploadContactsFile = async ({ token, formData }) => {
  const response = await axios.request({
    method: "post",
    maxBodyLength: Infinity,
    url: `${ApiEndpoint}campaigns/savebigcsvfile`,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: formData,
  });
  return response.data;
};

export const addPartnerDatabase = async ({ data, token }) => {
  const response = await httpClient(
    "POST",
    `${ApiEndpoint}campaigns/addPartnerDatabase`,
    {
      ...data,
    },
    token,
  );
  return response.data;
};

export const getCarriers = async ({ token }) => {
  const response = await httpClient("GET", `${ApiEndpoint}carriers`, {}, token);

  return response.data;
};

export const getPartners = async ({ token }) => {
  const response = await httpClient("GET", `${ApiEndpoint}partners`, {}, token);

  return response.data;
};
